/*
 * @Author: Teemo Ding
 * @Date: 2021-09-28 14:59:23
 * @LastEditTime: 2021-09-29 10:09:26
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/NumberInput/InputWithTextInForm.tsx
 */
import React from 'react';
import NumberInput from './NumberInput';
import styles from './css.less';

const InputWithTextInForm = (props) => {
  const { value, onChange, text, textClass, ...rest } = props;
  return (
    <div className={styles.inputWithTextInForm}>
      <NumberInput value={value} onChange={onChange} {...rest} />
      <span className={`${textClass} ${styles.text}`}>{text}</span>
    </div>
  );
};

export default InputWithTextInForm;
